
import React from "react";
import Dropdown from "../components/CustomFields/Dropdown";
import InputField from "../components/CustomFields/InputField";
import RadioButtonGroup from "../components/CustomFields/RadioButtonGroup";

const PreviousSchoolDetails = ({
  previousAffiliation,
  setPreviousAffiliation,
  errors,
  setErrors,
}) => {
  const velammalNexusSchools = [
    "Velammal Nexus A",
    "Velammal Nexus B",
    "Velammal Nexus C",
  ];

  const handleSchoolChange = (selectedSchool) => {
    setPreviousAffiliation({
      ...previousAffiliation,
      studyingSchool: selectedSchool,
      schoolName: selectedSchool === "Velammal" ? "" : previousAffiliation.schoolName,
    });

    if (errors.schoolName) {
      setErrors((prevErrors) => ({ ...prevErrors, schoolName: "" }));
    }
  };

  const handleSchoolNameChange = (e) => {
    const newValue = e.target.value;

    setPreviousAffiliation({
      ...previousAffiliation,
      schoolName: newValue,
    });

    if (errors.schoolName) {
      setErrors((prevErrors) => ({ ...prevErrors, schoolName: "" }));
    }
  };

  return (
    <div>
      <h3 className="text-lg font-bold mb-4 text-center">Previous School Details</h3>

      <div className="grid grid-cols-2 gap-4 mb-4">
        <RadioButtonGroup
          label="Studying School"
          options={[
            { label: "Velammal", value: "Velammal" },
            { label: "Others", value: "Others" },
          ]}
          selectedValue={previousAffiliation.studyingSchool}
          onChange={handleSchoolChange}
        />

        {previousAffiliation.studyingSchool === "Velammal" ? (
          <Dropdown
            label="Name of the School *"
            options={velammalNexusSchools}
            value={previousAffiliation.schoolName}
            onChange={handleSchoolNameChange}
            error={errors.schoolName}
          />
        ) : (
          <InputField
            label="Name of the School *"
            value={previousAffiliation.schoolName}
            onChange={handleSchoolNameChange}
            error={errors.schoolName}
          />
        )}
      </div>
    </div>
  );
};

export default PreviousSchoolDetails;
